import { supabase } from "@/integrations/supabase/client";
import { readEdgeError } from "@/lib/edgeError";

/**
 * Opens Stripe for the plan Dibs staff chose. The server reads the plan from the
 * business, so this only says where to come back to. Resolves false when the
 * account has already paid and there's nothing to open.
 */
export async function startPlanPayment(returnTo: "onboarding" | "billing"): Promise<boolean> {
  const { data, error } = await supabase.functions.invoke("onboarding-pay", {
    body: { return_to: returnTo },
  });
  if (error) throw new Error(await readEdgeError(error));
  if (data?.already_paid) return false;
  if (data?.error) throw new Error(data.error);
  if (!data?.url) throw new Error("Stripe did not return a checkout page.");
  window.location.assign(data.url);
  return true;
}
